// extracted by mini-css-extract-plugin
export default {"tags":"Tags_tags__rYIpp"};